import request from '@/api/request'
import { clearDictionaryCache } from '@/utils/dictionaryCache'

export interface Supplier {
  id: number
  name: string
  contactName?: string
  phone?: string
  email?: string
  address?: string
  isActive?: boolean
  createdAt?: string
}

export interface SupplierQuery {
  page?: number
  pageSize?: number
  keyword?: string
}

export function getSupplierList(params?: SupplierQuery) {
  return request.get('/suppliers', { params }).then((res: any) => res.data)
}

// 供应商下拉搜索（仅需登录，只返回 id/name/contactName/phone 基础字段；
// 供应商管理页数据需 supplier:read，用 getSupplierList）
export function searchSupplierOptions(params?: SupplierQuery) {
  return request.get('/suppliers/options', { params }).then((res: any) => res.data)
}

export function getSupplierById(id: number) {
  return request.get(`/suppliers/${id}`).then((res: any) => res.data)
}

// 供应商欠付余额（开单选择供应商时展示；无 supplier:balance:read 权限后端返回 balance:null）
export function getSupplierBalance(id: number) {
  return request.get(`/suppliers/${id}/balance`).then((res: any) => res.data)
}

export function createSupplier(data: Partial<Supplier>) {
  return request.post('/suppliers', data).then((res: any) => {
    clearDictionaryCache('supplier')
    return res.data
  })
}

export function updateSupplier(id: number, data: Partial<Supplier>) {
  return request.put(`/suppliers/${id}`, data).then((res: any) => {
    clearDictionaryCache('supplier')
    return res.data
  })
}

export function deleteSupplier(id: number) {
  return request.delete(`/suppliers/${id}`).then((res: any) => {
    clearDictionaryCache('supplier')
    return res.data
  })
}

export function getSupplierOptions() {
  return request.get('/suppliers/select/list').then((res: any) => res.data)
}
